<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'global.overview'|translate">
      <app-grid [grid]="grid"></app-grid>
      <button class="btn btn-primary ripple light pull-right my-3"  (click)="backToOverview()"
         type="button">{{'admin.dealer.view_dealers'|translate}}</button>
    </app-card>
  </div>
</div>

<app-modal-basic #readdModel>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'Option'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModel.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="companyName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-default ripple me-4" (click)="readdModel.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="readd()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>
